/**
 * Outdated Formatter.
 * @param {*} value
 * @param {*} row
 * @param {*} index
 * @param {*} field
 * @returns {string}
 */
window.outdatedFormatter = function(value, row, index, field) {
    let html = '';
    if (typeof row.outdated[field] !== "undefined"
        && row.outdated[field] !== null) {
        if (parseInt(row.outdated[field], 10) === 1) {
            html += '<span class="fontawesome fa fa-history" style="margin-right: 6px"></span>';
            html += '<span style="color: #888 !important">'+value+'</strong>';
        } else {
            html += value;
        }
    } else {
        html += '-';
    }
    return html;
}
